/* import __COLOCATED_TEMPLATE__ from './mobile-footer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();